export const filterMenuStyle = {
	wrapper: {
		background: 'var(--neutral-50)',
		borderRadius: '8px',
	},

	option: {
		width: '200px',
		cursor: 'pointer',

		'&:last-child': {
			color: 'var(--error-500)',
		},
	},

	buttonWrap: {
		display: 'flex',
		// maxWidth: '100px',
		width: 'fit-content',
		borderRadius: '8px',
		padding: '10px 16px',
		height: '44px',

		'@media (max-width: 768px)': {
			padding: '0px',
			width: '44px',
		},
	},

	button: {
		display: 'flex',
		fontWeight: 400,
		// maxWidth: 'auto',
		width: 'fit-content',
		padding: '10px 16px',

		span: {
			'@media (max-width: 768px)': {
				width: '24px',
				margin: '0px',
			},
		},

		svg: {
			fill: 'var(--neutral-900)',
			width: '24px',
		},

		'&.MuiButton-root': {
			color: 'var(--neutral-900)',
		},

		'@media (max-width: 768px)': {
			display: 'block',
			width: '44px',
			padding: '10px',
		},
	},

	activeButton: {
		fontWeight: 400,
		padding: '10px 16px',

		svg: {
			fill: 'var(--primary-500)',
		},
	},
};
